module.exports = __webpack_public_path__ + "img/synopsis.d8f871ac.jpg";